"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Adminet API Reference
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0.92
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectTypeToJSON = exports.ProjectTypeFromJSONTyped = exports.ProjectTypeFromJSON = exports.ProjectType = void 0;
/**
 * Project types for example:
 * * 0 Laskutyö
 * * 1 Urakkatyö
 * * 2 Keikkatyö
 * * 3 Oma työ
 * * 4 Takuutyö
 * * 5 Varastomyynti
 * * 6 Mahdolliset yrityskohtaiset tyypit
 * @export
 */
exports.ProjectType = {
    NUMBER_0: 0,
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3,
    NUMBER_4: 4,
    NUMBER_5: 5,
    NUMBER_6: 6
};
function ProjectTypeFromJSON(json) {
    return ProjectTypeFromJSONTyped(json, false);
}
exports.ProjectTypeFromJSON = ProjectTypeFromJSON;
function ProjectTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.ProjectTypeFromJSONTyped = ProjectTypeFromJSONTyped;
function ProjectTypeToJSON(value) {
    return value;
}
exports.ProjectTypeToJSON = ProjectTypeToJSON;
